import React from "react";
import CallUsForm from '../components/CallUs';

const CallUs = () => {
  return (
    <div>
      <CallUsForm
        source={''}
      />
    </div>
  );
};

export default CallUs;